import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { of as observableOf } from 'rxjs';
import { LocalStorage as SessionStorage } from '../constants/local-storage';
import jwt_decode from 'jwt-decode';
import { MatDialog } from '@angular/material/dialog';
import { AutoLogoutComponent } from '../components/auto-logout/auto-logout.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

enum debtOpportunityStage {
  ConfirmLoanNeeds = 'ece3b3ec-e98a-4d95-8ce0-eff28d771b26',
  ConfirmPersonalDetails = '2d8c0501-6d5d-4f7e-a0c0-e9afe7c52164',
  GatherSupportingDocuments = '2eda2878-affb-4fb3-ae3a-7d86a737a786',
  ProductRecommendation = 'ba486328-0485-4273-b4ab-9a9faaa22423',
  SubmissionToLender = 'f041dfe1-8e90-430c-9eb8-85ced7da8386',
  LoanApproval = '9ffd96ef-b806-4871-bf37-1a77a7edafc0',
  Loan = '4cbe1585-4102-4ea1-bf17-a9e5328020d5',
  SettlementBooked = '5da0f5ec-d070-48cf-946e-b4977631459a',
  SettlementComplete = '16a09f15-0fef-4315-853b-83d47be3b241',
}
enum SuperOpportunityStage {
  ConfirmNeeds = 'a11f4588-28ec-8a7a-86f4-1d06dd4200cb',
  CompleteFactFind = '2ee1ba75-0b75-40c9-9a75-9106f4182f16',
  GatherDocuments = 'bf20f70a-8f44-4ef6-8e28-2de5fe2921c9',
  ProductAndStrategyRecommendations = 'df4ce430-ccee-4a24-b922-da984b27adb9',
  ComplianceReview = 'b43ca487-1cca-40a5-8fbd-de322210386f',
  ClientPresentation = '25e0e995-b9bd-4269-a68d-87df4a17b455',
  ProcessApplication = '49e1509f-5970-42bd-85ae-0763915eae08',
  SettleRolloversAndInvestments = 'b50c99a7-a462-4b92-b960-b3a28f3de9a8',
  OngoingReview = '86a29103-435a-4d13-bfcf-7509cdedd7d7',
}
export enum managedInvestmentOpportunityStage {
  ConfirmInvestmentAccountNeeds = '7a2e74cf-784e-4a40-a6d4-52a78cfaddb1',
  CompleteFactFind = '56b2b8c3-810b-4538-b3da-dcabd8b82a27',
  GatherDocuments = '245e5731-0211-428d-aaf0-96bb04702f7d',
  ProductAndStrategyRecommendations = 'bf12435e-14a5-49b1-94ad-1587b1f50f66',
  ComplianceReview = 'ad8aa40b-c284-4eb7-a0e4-644035d7cd6a',
  ClientPresentation = '5ec99075-3775-4a62-9984-4a9c2f64cc9c',
  ProcessApplication = '8f49837e-20bd-4909-a1bc-f7f55c0f0bb2',
  SettleRolloversAndInvestments = 'a6f4e59d-8c3d-4b40-bace-b93e1ebed4a2',
  OngoingReview = '18101044-3c51-45f5-8b2b-4bc8405047c8',
}
export enum generalInsuranceOpportunityStage {
  ConfirmGeneralInsuranceNeeds = '3d2d49c7-17f7-4e61-be92-7aec9d824fe9',
  CompleteFactFind = '1e95aa1f-ce10-4a49-869f-73a17d4291cd',
  GatherDocuments = 'daa80418-f805-49d1-a5ed-24d6b515529c',
  ReferToInsuranceProvider = '7297956a-c73c-4971-ae62-e32114e29182',
  ConfirmInsuranceIsInForce = '06ddfd5e-8e72-47f5-b507-51534d4b62b3',
  OngoingReview = '81c266c2-9e8b-4dba-9e1f-93b7b92ef672',
}
export enum HealthInsuranceOpportunityStage {
  ConfirmHealthInsuranceNeeds = 'dd7d0688-38bc-484f-b3b6-00d974c00b3d',
  CompleteFactFind = 'a7e8150f-e667-4e32-a250-9f0e2aa4f1e9',
  GatherDocuments = '7279b36d-eb5b-42d8-a413-00b20233209b',
  ReferToInsuranceProvider = '59b5f987-c91a-4f54-9171-7c1084a7f1cd',
  ConfirmInsuranceIsInForce = '95c0ac62-c756-489a-a5ba-fd80097b3895',
  OngoingReview = 'cb3d67b2-d699-47bf-945d-4828c8be0e3e',
}
export enum EstatePlanningOpportunityStage {
  ConfirmEstatePlanningNeeds = '860c244b-9214-48f4-942e-267926726fdb',
  CompleteFactFind = 'd408967b-797a-48f2-9200-4233ff61d00d',
  GatherDocuments = 'c8d01d17-01f1-4e6e-9db9-545ffed1f890',
  ReferToLawyer = '143a267d-bfe0-48bb-9d5c-109c2f6c17b1',
  ConfirmEstatePlanIsInPlace = 'b4878a2f-d020-4b70-82a6-25b3fecc6f00',
  OngoingReview = 'dd752a5e-b234-4241-912f-a8937dab14ee',
}
export enum FinancialPlanningOpportunityStage {
  ConfirmFinancialPlanningNeeds = '97f16148-4f74-4ead-887d-c3546a6e8cf9',
  CompleteFactFind = '05de9ac0-c6cb-458d-8ce9-7b15f27f20d3',
  GatherDocuments = '47153fb5-92e1-4256-97c9-19e17695e210',
  ProductAndStrategyRecommendations = '761cd62f-cb3d-462c-86e9-d82be5aab55d',
  ComplianceReview = '274a2637-1ce8-414e-a870-1d581b726c89',
  ClientPresentation = '2533fab7-2fb0-4855-8a10-d55ece667f9b',
  ProcessApplication = '2d159854-8941-45c4-87df-9cfe05a27bee',
  SettleRolloversAndInvestments = 'ed46d589-c988-4fff-86da-a7cee673f375',
  OngoingReview = 'ecd6e91a-2ed8-4222-b45c-b41ca49685b6',
}
enum opportunityRouteBaseOnStage {
  'ece3b3ec-e98a-4d95-8ce0-eff28d771b26' = '../financial-goal',
  '2d8c0501-6d5d-4f7e-a0c0-e9afe7c52164' = '/user/confirm-identity-and-income',
  '2eda2878-affb-4fb3-ae3a-7d86a737a786' = '/user/complete-review-outstanding-items',
  'ba486328-0485-4273-b4ab-9a9faaa22423' = '/user/product-recommendation',
  'f041dfe1-8e90-430c-9eb8-85ced7da8386' = '/user/submission-to-lender',
  '9ffd96ef-b806-4871-bf37-1a77a7edafc0' = '/user/loan-approval',
  '4cbe1585-4102-4ea1-bf17-a9e5328020d5' = '/user/loan-document',
  '5da0f5ec-d070-48cf-946e-b4977631459a' = '/user/settlement-booked',
  '16a09f15-0fef-4315-853b-83d47be3b241' = '/user/settlement-complete',
}
enum SuperOpportunityRouteBaseOnStage {
  'a11f4588-28ec-8a7a-86f4-1d06dd4200cb' = '/superannuation',
  '2ee1ba75-0b75-40c9-9a75-9106f4182f16' = '/superannuation/confirm-identity-and-income',
  'bf20f70a-8f44-4ef6-8e28-2de5fe2921c9' = '/superannuation/complete-review-outstanding-items',
  'df4ce430-ccee-4a24-b922-da984b27adb9' = ' ',
  'b43ca487-1cca-40a5-8fbd-de322210386f' = ' ',
  '25e0e995-b9bd-4269-a68d-87df4a17b455' = ' ',
  '49e1509f-5970-42bd-85ae-0763915eae08' = ' ',
  'b50c99a7-a462-4b92-b960-b3a28f3de9a8' = ' ',
  '86a29103-435a-4d13-bfcf-7509cdedd7d7' = ' ',
}
enum managedInvestmentOpportunityRouteBaseOnStage {
  '7a2e74cf-784e-4a40-a6d4-52a78cfaddb1' = '/managed-account',
  '56b2b8c3-810b-4538-b3da-dcabd8b82a27' = '/managed-account/investment-risk-profile',
  '245e5731-0211-428d-aaf0-96bb04702f7d' = '/managed-account/complete-review-outstanding-items',
  'bf12435e-14a5-49b1-94ad-1587b1f50f66' = '',
  'ad8aa40b-c284-4eb7-a0e4-644035d7cd6a' = '',
  '5ec99075-3775-4a62-9984-4a9c2f64cc9c' = '',
  '8f49837e-20bd-4909-a1bc-f7f55c0f0bb2' = '',
  'a6f4e59d-8c3d-4b40-bace-b93e1ebed4a2' = '',
  '18101044-3c51-45f5-8b2b-4bc8405047c8' = '',
}
enum GeneralInsuranceOpportunityRouteBaseOnStage {
  '3d2d49c7-17f7-4e61-be92-7aec9d824fe9' = '/general-insurance',
  '1e95aa1f-ce10-4a49-869f-73a17d4291cd' = '/general-insurance/insurance-advice',
  'daa80418-f805-49d1-a5ed-24d6b515529c' = '/general-insurance/complete-review-outstanding-items',
  '7297956a-c73c-4971-ae62-e32114e29182' = '',
  '06ddfd5e-8e72-47f5-b507-51534d4b62b3' = '',
  '81c266c2-9e8b-4dba-9e1f-93b7b92ef672' = '',
}
enum HealthInsuranceOpportunityRouteBaseOnStage {
  'dd7d0688-38bc-484f-b3b6-00d974c00b3d' = '/health-insurance',
  'a7e8150f-e667-4e32-a250-9f0e2aa4f1e9' = '/health-insurance/insurance',
  '7279b36d-eb5b-42d8-a413-00b20233209b' = '/health-insurance/complete-review-outstanding-items',
  '59b5f987-c91a-4f54-9171-7c1084a7f1cd' = '',
  '95c0ac62-c756-489a-a5ba-fd80097b3895' = '',
  'cb3d67b2-d699-47bf-945d-4828c8be0e3e' = '',
}
enum EstatePlanningOpportunityRouteBaseOnStage {
  '860c244b-9214-48f4-942e-267926726fdb' = '/estate-planning',
  'd408967b-797a-48f2-9200-4233ff61d00d' = '/estate-planning/tell-us-about-your-family',
  'c8d01d17-01f1-4e6e-9db9-545ffed1f890' = '/estate-planning/complete-review-outstanding-items',
  '143a267d-bfe0-48bb-9d5c-109c2f6c17b1' = '',
  'b4878a2f-d020-4b70-82a6-25b3fecc6f00' = '',
  'dd752a5e-b234-4241-912f-a8937dab14ee' = '',
}

enum FinancialPlanningOpportunityRouteBaseOnStage {
  '97f16148-4f74-4ead-887d-c3546a6e8cf9' = '/financial-planning',
  '05de9ac0-c6cb-458d-8ce9-7b15f27f20d3' = '/financial-planning/financial-goal',
  '47153fb5-92e1-4256-97c9-19e17695e210' = '/financial-planning/complete-review-outstanding-items',
  '761cd62f-cb3d-462c-86e9-d82be5aab55d' = '',
  '274a2637-1ce8-414e-a870-1d581b726c89' = '',
  '2533fab7-2fb0-4855-8a10-d55ece667f9b' = '',
  '2d159854-8941-45c4-87df-9cfe05a27bee' = '',
  'ed46d589-c988-4fff-86da-a7cee673f375' = '',
  'ecd6e91a-2ed8-4222-b45c-b41ca49685b6' = '',
}
/**
 * AuthenticationService
 * @description
 * This is auth service, responsible for managing the Authentication related task.
 */

const MINUTES_UNITL_AUTO_LOGOUT = 15; // in mins
const CHECK_INTERVAL = 15000; // in ms
const STORE_KEY = 'lastAction';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  isLoggedIn = false;
  triggerEmailDocumentFlow = false;
  resetUserForm = new EventEmitter<boolean>();
  headerImage = new Subject<boolean>();
  headerDetail = new Subject<boolean>();
  userDetail = new Subject<boolean>();
  TimeOutVariable: number;
  newOpportunity = new EventEmitter<boolean>();
  disableOpp = new Subject<boolean>();
  updateImage = new Subject<boolean>();
  fetchingData = new Subject<string>();
  updateclientData = new Subject<any>();
  opportunityType = {
    854500000: 'Refinance my debt',
    854500001: 'Buy a property',
    854500002: 'Buy a car or equipment',
    854500003: 'Apply for cash out to invest or renovate',
    854500004: 'Acquire a business or refinance business debts',
    854500005: 'Borrow or refinance debt in my SMSF',
  };
  constructor(
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.check();
    this.initListener();
    this.initInterval();
  }

  // Auto logout functionality
  public getLastAction() {
    return parseInt(localStorage.getItem(STORE_KEY), 10);
  }
  public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }

  initListener() {
    document.body.addEventListener('click', () => this.reset());
    document.body.addEventListener('mouseover', () => this.reset());
    document.body.addEventListener('mouseout', () => this.reset());
    document.body.addEventListener('keydown', () => this.reset());
    document.body.addEventListener('keyup', () => this.reset());
    document.body.addEventListener('keypress', () => this.reset());
  }

  reset() {
    this.setLastAction(Date.now());
  }

  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }

  check() {
    const now = Date.now();
    const timeleft =
      this.getLastAction() + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;

    if (isTimeout) {
      if (this.getLoginUserId()) {
        const dialogRef = this.dialog.open(AutoLogoutComponent, {
          width: '530px',
          // data: { xreadId: id, type: typeInput }
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            if (result.logout) {
              this.dialog.closeAll();
              this.logout();
            }
          }
          this.reset();
        });

        // this.dialog.closeAll();
        // this.logout();
        localStorage.removeItem(STORE_KEY);
        localStorage.clear();
      }
    }
  }

  /**
   * Check if used is authenticated or not
   */
  IsAuthUser(): boolean {
    if (
      window.sessionStorage[SessionStorage.userToken] &&
      JSON.parse(window.sessionStorage[SessionStorage.userToken]).authToken
    ) {
      this.isLoggedIn = true;

      return true;
    } else {
      return false;
    }
  }
  IsAuthenticated() {
    const promise = new Promise((resolve, reject) => {
      resolve(this.IsAuthUser());
    });
    return promise;
  }

  /**
   * Update token
   * @param data token to update
   */
  updateLoginUserDetail(data: any) {
    if (window.sessionStorage[SessionStorage.userToken]) {
      const authObject = JSON.parse(
        window.sessionStorage[SessionStorage.userToken]
      );
      // Update the user details here
      window.sessionStorage[SessionStorage.userToken] =
        JSON.stringify(authObject);
    }
  }
  showSnackBarMsg(msg: string, time = 3000) {
    this.snackBar.open(msg, 'Done', {
      duration: time,
    });
  }
  getOpportunityById(id: string) {
    const allOpp = this.getAllOpportunity();
    const found = allOpp.find((el) => el.opportunityid == id);
    if (found.tlx_leadfor == 2) {
      const name = this.opportunityType[found.tlx_debtneedstransactiontype];
      return name;
    } else {
      const name = found.name.split('-');
      return name[1];
    }
  }

  /**
   * Get user access token in decoded form
   */
  getDecodedUserAccessToken() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.decodedToken])
        .decodedToken;
    } else {
      return null;
    }
  }
  getUSerType() {
    const userData = this.getDecodedUserAccessToken();
    if (userData) {
      return userData.contactDetails[0].tlx_logintype;
    } else {
      return null;
    }
  }
  getUserGenderType() {
    const userData = this.getDecodedUserAccessToken();
    if (userData) {
      return userData.contactDetails[0].gendercode;
    } else {
      return null;
    }
  }
  setDecodedToken(decodedtoken: any) {
    const decodedData = { decodedToken: decodedtoken };
    window.sessionStorage[SessionStorage.decodedToken] =
      JSON.stringify(decodedData);

    this.userDetail.next(true);
  }

  // getUserDecodedToken() {
  //   if (this.IsAuthUser()) {
  //     return JSON.parse(window.sessionStorage[SessionStorage.decodedToken])
  //       .decodedToken;
  //   } else {
  //     return null;
  //   }
  // }
  /**
   * Get user access token from local storage
   */
  getUserAccessToken() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.userToken])
        .authToken;
    } else {
      return null;
    }
  }

  /**
   * Save the logged in user detail to local storage
   * @param token token to store
   */
  setLoginUserDetail(token: any) {
    const tokenObj = { authToken: token };
    window.sessionStorage[SessionStorage.userToken] = JSON.stringify(tokenObj);
    this.isLoggedIn = true;
    this.setOpportunityinSession([]);
    this.setCreditFileFlag(true);
    this.setDecodedToken(jwt_decode(token));

    this.headerDetail.next(true);
    this.resetUserForm.emit(false);
    this.setPartnerid('');
    this.setAllRelatedMemberInSession([]);
    this.setAllOccupationInSession([]);
    this.setAllIllionInstatiteInSession([]);
    this.setAllInsuranceProviderInSession([]);
    this.setAllCountries([]);
  }

  /**
   * Get logged in user id from token
   */
  getLoginUserId() {
    const token = this.getDecodedUserAccessToken();
    if (token) {
      return token['contactId'];
    }
    return null;
  }
  /**
   * Get primary user id from token
   */
  getPrimaryUserId() {
    const token = this.getDecodedUserAccessToken();
    if (token) {
      return token['primaryContactId'];
    }
    return null;
  }

  getCurrentLoginUSerType() {
    if (this.getPrimaryUserId() == this.getLoginUserId()) {
      return 'primary';
    } else {
      return 'secondary';
    }
  }
  /**
   * Get employment Status from token
   */
  getEmploymentStatus() {
    const token = this.getDecodedUserAccessToken();
    if (token) {
      return token['contactDetails'][0].tlx_employmentstatus;
    }
    return null;
  }

  getFieldDataFromToken(fieldName: string) {
    const token = this.getDecodedUserAccessToken();
    if (token) {
      return token['contactDetails'][0][fieldName];
    }
    return null;
  }

  getPreservationAge() {
    const token = this.getDecodedUserAccessToken();
    if (token) {
      return token['contactDetails'][0].pepl_preservationage;
    }
    return null;
  }
  getRetirementAge() {
    const birthdayData = this.getFieldDataFromToken('birthdate');
    const birthday = new Date(birthdayData);
    birthday.setFullYear(birthday.getFullYear() + 67);
    return birthday;
  }
  getDebtCurrentUrl(currentStage: string): string {
    return opportunityRouteBaseOnStage[currentStage];
  }
  getSuperCurrentUrl(currentStage: string): string {
    return SuperOpportunityRouteBaseOnStage[currentStage];
  }
  getmanagedInvestmentCurrentUrl(currentStage: string): string {
    return managedInvestmentOpportunityRouteBaseOnStage[currentStage];
  }
  getGeneralInsuranceCurrentUrl(currentStage: string): string {
    return GeneralInsuranceOpportunityRouteBaseOnStage[currentStage];
  }
  getHealthInsuranceCurrentUrl(currentStage: string): string {
    return HealthInsuranceOpportunityRouteBaseOnStage[currentStage];
  }
  getEstatePlanningCurrentUrl(currentStage: string): string {
    return EstatePlanningOpportunityRouteBaseOnStage[currentStage];
  }
  getFinancialPlanningCurrentUrl(currentStage: string): string {
    return FinancialPlanningOpportunityRouteBaseOnStage[currentStage];
  }
  /**
   * Get logged in user email from token
   */
  getLoginUserEmail() {
    if (window.sessionStorage[SessionStorage.userToken]) {
      return JSON.parse(window.sessionStorage[SessionStorage.userToken]).Email;
    }
  }
  /**
   * Get logged in user email from token
   */
  getUserAccountId() {
    const token = this.getDecodedUserAccessToken();
    if (token) {
      return token['contactDetails'][0].accountId;
    }
    return null;
  }
  getNominationType() {
    const token = this.getDecodedUserAccessToken();
    if (token) {
      const tlx_nomination = token['contactDetails'][0].tlx_nomination + '';
      const tlx_nominationtype =
        token['contactDetails'][0].tlx_nominationtype + '';
      return { tlx_nomination, tlx_nominationtype };
    }
    return null;
  }
  setNominationType(tlx_nomination: string, tlx_nominationtype: string) {
    const userDataToken = this.getDecodedUserAccessToken();
    if (userDataToken) {
      userDataToken['contactDetails'][0].tlx_nomination = tlx_nomination;
      userDataToken['contactDetails'][0].tlx_nominationtype =
        tlx_nominationtype;
      this.setDecodedToken(userDataToken);
    }
  }
  getUserEmailId() {
    const token = this.getDecodedUserAccessToken();

    if (token) {
      return token['contactDetails'][0].emailaddress1;
    }
    return null;
  }
  /**
   * Gets login user name
   * @returns  user name
   */
  getLoginUserName() {
    const token = this.getDecodedUserAccessToken();
    if (token) {
      return token['contactDetails'][0]['firstname'].replace(/\s/g, '').trim();
    }
    return null;
  }
  getLoginUserFullName() {
    const token = this.getDecodedUserAccessToken();
    if (token) {
      const name = token['contactDetails'][0]['fullname'];
      return name;
    }
    return null;
  }
  /**
   * Save the logged in user image to local storage
   * @param token token to store
   */
  setLoginUserImage(image: any) {
    const tokenObj = { image: image };
    window.sessionStorage[SessionStorage.image] = JSON.stringify(tokenObj);
    this.headerImage.next(true);
  }

  deleteLoginUserImage() {
    const tokenObj = { image: null };
    window.sessionStorage[SessionStorage.image] = JSON.stringify(tokenObj);
    this.headerImage.next(true);
  }

  /**
   * Gets login image
   * @returns  user image
   */
  getLoginImage() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.image]).image;
    } else {
      return null;
    }
  }

  /**
   * Delete user access token
   * @param redirect Redirect url if required
   */
  deleteUserAccessToken(redirect: boolean = true) {
    window.sessionStorage.clear();

    // if (redirect === true) {
    //   // this.router.navigate(["/login"]);
    // }
  }
  /**
   * Gets current opportunityId
   * @returns  current opportunityId
   */
  getCurrentOpportunityId() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.opportunityid])
        .currentOpportunityid;
    } else {
      return null;
    }
  }

  getCurrentSuperOpportunityId() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.superOppId])
        ?.currentOpportunityid;
    } else {
      return null;
    }
  }
  getCurrentInvestmentAccountId(leadFor: number) {
    if (this.IsAuthUser()) {
      const allOpportunity = JSON.parse(
        window.sessionStorage[SessionStorage.oppData]
      ).oppData;
      let id;
      allOpportunity.forEach((element) => {
        if (element.tlx_leadfor == leadFor) {
          id = element._new_investmentaccount_value;
        }
      });
      return id;
    } else {
      return null;
    }
  }
  getOPPByLeadFor(leadFor: number) {
    if (this.IsAuthUser()) {
      const allOpportunity = JSON.parse(
        window.sessionStorage[SessionStorage.oppData]
      ).oppData;
      let id;
      allOpportunity.forEach((element) => {
        if (element.tlx_leadfor == leadFor) {
          id = element.opportunityid;
        }
      });
      return id;
    } else {
      return null;
    }
  }
  getDebtBusinessProcessId() {
    if (this.IsAuthUser()) {
      const allOpportunity = JSON.parse(
        window.sessionStorage[SessionStorage.oppData]
      ).oppData;
      let id;
      allOpportunity.forEach((element) => {
        if (element.tlx_leadfor == 2) {
          id = element.businessprocessflowinstanceid;
        }
      });
      return id;
    } else {
      return null;
    }
  }
  getDebtopportunity() {
    if (this.IsAuthUser()) {
      const allOpportunity = JSON.parse(
        window.sessionStorage[SessionStorage.oppData]
      ).oppData;
      let opp;
      allOpportunity.forEach((element) => {
        if (element.tlx_leadfor == 2) {
          opp = element;
        }
      });
      return opp;
    } else {
      return null;
    }
  }
  getCurrentInvestmentOpportunityId() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.investmentOppId])
        ?.currentOpportunityid;
    } else {
      return null;
    }
  }
  getCurrentGeneralInsuranceOpportunityId() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.generalOppId])
        ?.currentOpportunityid;
    } else {
      return null;
    }
  }
  getCurrentHealthInsuranceOpportunityId() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.healthOppId])
        ?.currentOpportunityid;
    } else {
      return null;
    }
  }
  getCurrentEstatePlanningOpportunityId() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.estateOppId])
        ?.currentOpportunityid;
    } else {
      return null;
    }
  }
  getCurrentFinancialPlanningOpportunityId() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.financialOppId])
        ?.currentOpportunityid;
    } else {
      return null;
    }
  }

  /**
   * Gets current opportunityId
   * @returns  current opportunityId
   */
  getAllOpportunity() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.oppData]).oppData;
    } else {
      return null;
    }
  }

  /**
   * Save the  opportunityId  to local storage
   * @param token token to store
   */
  setOpportunityinSession(data) {
    const tokenObj = { oppData: data };
    window.sessionStorage[SessionStorage.oppData] = JSON.stringify(tokenObj);
    this.updateSideBar();
  }
  /**
   * Save the  backurl  to local storage
   * @param token token to store
   */
  setBackUrl(url) {
    const tokenObj = { backurl: url };
    window.sessionStorage[SessionStorage.url] = JSON.stringify(tokenObj);
  }

  /**
   * Save the  credit file  to local storage
   * @param token token to store
   */
  setCreditFileFlag(a: boolean) {
    const tokenObj = { flag: a };
    window.sessionStorage[SessionStorage.creditFileReviewFlag] =
      JSON.stringify(tokenObj);
  }
  /**
   * Gets credit file review url
   * @returns
   */
  getCreditFileFlag() {
    if (this.IsAuthUser()) {
      return JSON.parse(
        window.sessionStorage[SessionStorage.creditFileReviewFlag]
      ).flag;
    } else {
      return null;
    }
  }

  /**
   * Save the  backurl  to local storage for notification section
   * @param token token to store
   */
  setNotificationBackUrl(url) {
    const tokenObj = { backurl: url };
    window.sessionStorage[SessionStorage.url2] = JSON.stringify(tokenObj);
  }
  /**
   * Gets back url
   * @returns
   */
  getbackurl() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.url]).backurl;
    } else {
      return null;
    }
  }
  /**
   * Gets back url
   * @returns
   */
  getbackNotificationurl() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.url2]).backurl;
    } else {
      return null;
    }
  }

  updateSideBar() {
    this.newOpportunity.emit(true);
  }

  updtateOpportunityStage(value) {
    const currentOpportunityid = this.getCurrentOpportunityId();

    const allOpportunity = this.getAllOpportunity();

    const newOpportunity = [];
    allOpportunity.forEach((element) => {
      if (element._bpf_opportunityid_value === currentOpportunityid) {
        element._activestageid_value = debtOpportunityStage[`${value}`];
        element._activestageid_value_Formatted = value;
      }
      newOpportunity.push(element);
    });
    this.setOpportunityinSession(newOpportunity);
    // this.newOpportunity.emit(true);
  }
  updtateSuperOpportunityStage(value) {
    const currentOpportunityid = this.getCurrentSuperOpportunityId();

    const allOpportunity = this.getAllOpportunity();

    const newOpportunity = [];
    allOpportunity.forEach((element) => {
      if (element._bpf_opportunityid_value === currentOpportunityid) {
        element._activestageid_value = SuperOpportunityStage[`${value}`];
        element._activestageid_value_Formatted = value;
      }
      newOpportunity.push(element);
    });
    this.setOpportunityinSession(newOpportunity);
    // this.newOpportunity.emit(true);
  }
  updtatemanagedInvestmentOpportunityStage(value) {
    const currentOpportunityid = this.getCurrentInvestmentOpportunityId();

    const allOpportunity = this.getAllOpportunity();

    const newOpportunity = [];
    allOpportunity.forEach((element) => {
      if (element._bpf_opportunityid_value === currentOpportunityid) {
        element._activestageid_value =
          managedInvestmentOpportunityStage[`${value}`];
        element._activestageid_value_Formatted = value;
      }
      newOpportunity.push(element);
    });
    this.setOpportunityinSession(newOpportunity);
    // this.newOpportunity.emit(true);
  }
  updtateGeneralInsuranceOpportunityStage(value) {
    const currentOpportunityid = this.getCurrentGeneralInsuranceOpportunityId();

    const allOpportunity = this.getAllOpportunity();

    const newOpportunity = [];
    allOpportunity.forEach((element) => {
      if (element._bpf_opportunityid_value === currentOpportunityid) {
        element._activestageid_value =
          generalInsuranceOpportunityStage[`${value}`];
        element._activestageid_value_Formatted = value;
      }
      newOpportunity.push(element);
    });
    this.setOpportunityinSession(newOpportunity);
    // this.newOpportunity.emit(true);
  }

  updtateHealthInsuranceOpportunityStage(value) {
    const currentOpportunityid = this.getCurrentHealthInsuranceOpportunityId();

    const allOpportunity = this.getAllOpportunity();

    const newOpportunity = [];
    allOpportunity.forEach((element) => {
      if (element._bpf_opportunityid_value === currentOpportunityid) {
        element._activestageid_value =
          HealthInsuranceOpportunityStage[`${value}`];
        element._activestageid_value_Formatted = value;
      }
      newOpportunity.push(element);
    });
    this.setOpportunityinSession(newOpportunity);
    // this.newOpportunity.emit(true);
  }

  updtateEstatePlanningOpportunityStage(value) {
    const currentOpportunityid = this.getCurrentEstatePlanningOpportunityId();

    const allOpportunity = this.getAllOpportunity();

    const newOpportunity = [];
    allOpportunity.forEach((element) => {
      if (element._bpf_opportunityid_value === currentOpportunityid) {
        element._activestageid_value =
          EstatePlanningOpportunityStage[`${value}`];
        element._activestageid_value_Formatted = value;
      }
      newOpportunity.push(element);
    });
    this.setOpportunityinSession(newOpportunity);
    // this.newOpportunity.emit(true);
  }
  updtateFinancialPlanningOpportunityStage(value) {
    const currentOpportunityid =
      this.getCurrentFinancialPlanningOpportunityId();

    const allOpportunity = this.getAllOpportunity();

    const newOpportunity = [];
    allOpportunity.forEach((element) => {
      if (element._bpf_opportunityid_value === currentOpportunityid) {
        element._activestageid_value =
          FinancialPlanningOpportunityStage[`${value}`];
        element._activestageid_value_Formatted = value;
      }
      newOpportunity.push(element);
    });
    this.setOpportunityinSession(newOpportunity);
    // this.newOpportunity.emit(true);
  }
  /**
   * Save the current opportunityId  to local storage
   * @param token token to store
   */
  setCurrentDebtOpportunityId(id: string) {
    const tokenObj = { currentOpportunityid: id };
    window.sessionStorage[SessionStorage.opportunityid] =
      JSON.stringify(tokenObj);
  }
  setCurrentSuperOpportunityId(id: string) {
    const tokenObj = { currentOpportunityid: id };
    window.sessionStorage[SessionStorage.superOppId] = JSON.stringify(tokenObj);
  }
  setCurrentInvestmentOpportunityId(id: string) {
    const tokenObj = { currentOpportunityid: id };
    window.sessionStorage[SessionStorage.investmentOppId] =
      JSON.stringify(tokenObj);
  }
  setCurrentHealthInsuranceOpportunityId(id: string) {
    const tokenObj = { currentOpportunityid: id };
    window.sessionStorage[SessionStorage.healthOppId] =
      JSON.stringify(tokenObj);
  }
  setCurrentGeneralInsuranceOpportunityId(id: string) {
    const tokenObj = { currentOpportunityid: id };
    window.sessionStorage[SessionStorage.generalOppId] =
      JSON.stringify(tokenObj);
  }
  setCurrentEstatePlanningOpportunityId(id: string) {
    const tokenObj = { currentOpportunityid: id };
    window.sessionStorage[SessionStorage.estateOppId] =
      JSON.stringify(tokenObj);
  }
  setCurrentFinancialPlanningOpportunityId(id: string) {
    const tokenObj = { currentOpportunityid: id };
    window.sessionStorage[SessionStorage.financialOppId] =
      JSON.stringify(tokenObj);
  }

  setCurrentLifeInsuranceOpportunityId(id: string) {
    const tokenObj = { currentOpportunityid: id };
    window.sessionStorage[SessionStorage.lifeOppId] = JSON.stringify(tokenObj);
  }
  getCurrentLifeInsuranceOpportunityId() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.lifeOppId])
        ?.currentOpportunityid;
    } else {
      return null;
    }
  }

  setAllRelatedMemberInSession(data) {
    const tokenObj = { relatedMember: data };
    window.sessionStorage[SessionStorage.relatedMember] =
      JSON.stringify(tokenObj);
  }
  setAllOccupationInSession(data) {
    const tokenObj = { occupation: data };
    window.sessionStorage[SessionStorage.occupation] = JSON.stringify(tokenObj);
  }
  getAllOccupationFromSession() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.occupation])
        ?.occupation;
    } else {
      return null;
    }
  }
  getAllRelatedMemberFromSession() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.relatedMember])
        ?.relatedMember;
    } else {
      return null;
    }
  }

  setAllCountries(data) {
    const tokenObj = { allContries: data };
    window.sessionStorage[SessionStorage.allCountries] =
      JSON.stringify(tokenObj);
  }

  getAllCountries() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.allCountries])
        ?.allContries;
    } else {
      return null;
    }
  }
  setAllIllionInstatiteInSession(data) {
    const tokenObj = { allInstitute: data };
    window.sessionStorage[SessionStorage.illionInstitute] =
      JSON.stringify(tokenObj);
  }
  getAllIllionInstatiteFromSession() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.illionInstitute])
        ?.allInstitute;
    } else {
      return null;
    }
  }

  setAllInsuranceProviderInSession(data) {
    const tokenObj = { provider: data };
    window.sessionStorage[SessionStorage.insuranceProvider] =
      JSON.stringify(tokenObj);
  }
  getAllInsuranceProviderFromSession() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.insuranceProvider])
        ?.provider;
    } else {
      return null;
    }
  }

  setPartnerid(id: string) {
    const tokenObj = { partnerid: id };
    window.sessionStorage[SessionStorage.partnerId] = JSON.stringify(tokenObj);
  }
  getPartnerId() {
    if (this.IsAuthUser()) {
      return JSON.parse(window.sessionStorage[SessionStorage.partnerId])
        ?.partnerid;
    } else {
      return null;
    }
  }
  logout() {
    this.dialog.closeAll();
    this.deleteUserAccessToken();
    this.isLoggedIn = false;
    this.headerDetail.next(false);
    this.resetUserForm.emit(true);
    this.headerImage.next(true);
    if (this.TimeOutVariable) {
      clearTimeout(this.TimeOutVariable);
    }
    this.router.navigate(['/']);
    window.scroll(0, 0);
  }

  autoLogout() {
    const userData = this.getDecodedUserAccessToken();
    if (userData) {
      const dateNow = new Date();
      const expiryTime = userData.exp;
      const currentTime = dateNow.getTime() / 1000;
      const expireDuration = expiryTime - currentTime;
      const expireAfter = expireDuration * 1000;

      console.log('expireAfter ', expireDuration, ' sec.');
      this.TimeOutVariable = setTimeout(() => {
        this.logout();
        this.showSnackBarMsg('Token Expired, Please Login Again!', 6000);
      }, expireAfter);
    }
  }

  gotoUrl(url, queryParamsValue?) {
    if (queryParamsValue) {
      this.router.navigate([url], {
        queryParams: queryParamsValue,
      });
    } else {
      this.router.navigate([url]);
    }
    window.scroll(0, 0);
  }

  getCurrentUrl(): string {
    return this.router.url.split('?')[0];
  }
}
